export default __webpack_public_path__ + "static/media/Cleopatra_2.cfcdd03f.png";